export default __webpack_public_path__ + "static/media/closet5-before1.4428e0bc.jpg";